import { ButtonList } from '../button-list';

export class GroupButton extends ButtonList {
  name = 'groups';
}
